// extracted by mini-css-extract-plugin
module.exports = {"page-not-found":"PageNotFound_page-not-found__pC1CR","page-not-found-content":"PageNotFound_page-not-found-content__4ONJP"};